@if (actualPage) {
  <div class="offerView offer-view">
    <div class="mb-5 offer-view__image-container">
      @if (actualPage.viewFile) {
        <img class="offer-view__image"
             [ngSrc]="actualPage.viewFile.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             [alt]="actualPage.viewFile.altText">
      }
    </div>
    <div class="mb-5 offer-view__description-container">
      <h4 class="offerViewDescription offer-view__description" [innerHtml]="actualPage.viewDescription | toSafeHtml"></h4>
    </div>
  </div>
}

<div class="landingPage landing-page">
  <div class="row landing-page__row">
    <div [className]="(hasCustomResponsivClasses() ? getCustomResponsivClasses() : 'col-12 col-md-6 col-lg-4' ) + ' mb-4 landing-page__card-container'"
         *ngFor="let card of cards">
      @if (card.isLogIn) {
        <mat-card appearance="outlined" class="pointer h-100 landing-page__card landing-page__card--login"
                  routerLink="{{card.route}}" (click)="onClickEvent()">
          <mat-card-header class="landing-page__card-header">
            <mat-card-title class="landing-page__card-title">
              <app-login #login class="landing-page__login"></app-login>
            </mat-card-title>
          </mat-card-header>
          @if (card.image) {
            <img mat-card-image class="landing-page__card-image"
                 [ngSrc]="card.image.src"
                 [width]="imageService.width"
                 [height]="imageService.height"
                 [priority]="true"
                 [alt]="card.image.altText"
                 (error)="onImgError($event, card.image.src)">
          }
          <mat-card-content class="landing-page__card-content">
            {{ (!login.isAuthenticated) ? translationService.getTranslation('landing_login') : translationService.getTranslation('landing_logout') }}
          </mat-card-content>
        </mat-card>
      } @else {
        <mat-card appearance="outlined" class="pointer h-100 landing-page__card" (click)="navigateToRoute(card)">
          <mat-card-header class="landing-page__card-header">
            <mat-card-title class="landing-page__card-title">
              {{ card.title }}
            </mat-card-title>
          </mat-card-header>
          @if (card.image) {
            <img mat-card-image class="landing-page__card-image"
                 [ngSrc]="card.image.src"
                 [width]="imageService.width"
                 [height]="imageService.height"
                 [priority]="true"
                 [alt]="card.image.altText"
                 (error)="onImgError($event, card.image.src)">
          }
          <mat-card-content class="landing-page__card-content">
            {{ card.description }}
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
